var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('intro-panel'),(!_vm.isIntitle)?[_c('solution-panel'),_c('test-panel')]:_vm._e(),_c('contact-panel')],2)}
var staticRenderFns = []

export { render, staticRenderFns }